import { images } from ".";

const events = [
    {
        id: 1,
        image: images.event1,
        title: "Adventure Travel Tours",
        details: {
            date: "Sat, 01 Jun 2024",
            time: "7:00 AM - 9:00 PM",
            venue: "World Adventure Hub",
            organizer: "Adventure Enthusiasts Association",
            number: "+123-456-7890",
            email: "info@adventurehub.com",
            entryFee: "$50 per person"
        },
        paragraphs: [
            "Join us for an unforgettable day with our Adventure Travel Tours. Whether you're a seasoned explorer or a first-time adventurer, this event offers something for everyone who loves the great outdoors.",
            "Experience nature like never before through guided treks, group camping, and social activities that foster community and connection in stunning surroundings."
        ],
        gallery: [
            images.event1Gallery1,
            images.event1Gallery2
        ],
        agenda: [
            "7:00 AM - 8:00 AM: Meet and Greet at World Adventure Hub.",
            "8:00 AM - 12:00 PM: Morning Hiking and Trekking Activities.",
            "12:00 PM - 1:00 PM: Lunch Break.",
            "1:00 PM - 5:00 PM: Afternoon Adventure Activities (Camping, Exploring).",
            "5:00 PM - 6:00 PM: Wrap-up and Reflection.",
            "6:00 PM - 9:00 PM: Social Gathering and Dinner."
        ],
        teamIds: [1, 2],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d506888.3297748932!2d-113.0572867!3d37.1782916!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x874c46a1e72f5e57%3A0x911c79d88e26fc64!2sZion%20National%20Park!5e0!3m2!1sen!2sus!4v1715805700000!5m2!1sen!2sus",
    },
    {
        id: 2,
        image: images.event2,
        title: "Camping Essentials",
        details: {
            date: "Fri, 31 May 2024",
            time: "10:00 AM - 4:00 PM",
            venue: "Gear Up Center",
            organizer: "Adventure Enthusiasts Association",
            number: "+123-456-7890",
            email: "info@adventurehub.com",
            entryFee: "$50 per person"
        },
        paragraphs: [
            "Prepare for your next adventure with our Camping Essentials event! Discover must-have gear, survival tips, and expert advice for a safe and enjoyable outdoor experience.",
            "From tent setups to cooking demos and gear reviews, this event is perfect for both beginners and seasoned campers looking to upgrade their toolkit."
        ],
        gallery: [
            images.event2Gallery1,
            images.event2Gallery2
        ],
        agenda: [
            "10:00 AM - 10:30 AM: Registration and Welcome Session.",
            "10:30 AM - 12:00 PM: Camping Gear Demonstration and Tutorials.",
            "12:00 PM - 1:00 PM: Lunch Break.",
            "1:00 PM - 3:00 PM: Outdoor Survival Tips and Hands-On Activities.",
            "3:00 PM - 4:00 PM: Q&A, Product Giveaways, and Networking."
        ],
        teamIds: [3, 4],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3193.340689441532!2d-119.574233!3d37.7455701!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8096f1eeecae5a01%3A0x94f98d0eb5e6f59!2sYosemite%20Valley%2C%20CA%2095379%2C%20USA!5e0!3m2!1sen!2sus!4v1715806554299!5m2!1sen!2sus",
    },
    {
        id: 3,
        image: images.event3,
        title: "Trail Maintenance",
        details: {
            date: "Wed, 05 Jun 2024",
            time: "8:00 AM - 12:00 PM",
            venue: "Forest Preserve",
            organizer: "Adventure Enthusiasts Association",
            number: "+123-456-7890",
            email: "info@adventurehub.com",
            entryFee: "$50 per person"
        },
        paragraphs: [
            "Join our Trail Maintenance event and help preserve the natural beauty of our favorite hiking paths. This hands-on experience is perfect for nature lovers who want to give back to the great outdoors.",
            "Learn trail upkeep techniques, collaborate with fellow volunteers, and enjoy a morning of meaningful work surrounded by nature."
        ],
        gallery: [
            images.event3Gallery1,
            images.event3Gallery2
        ],
        agenda: [
            "8:00 AM - 8:30 AM: Meet and Safety Briefing.",
            "8:30 AM - 10:30 AM: Trail Clearing and Maintenance Activities.",
            "10:30 AM - 11:30 AM: Rest Break and Team Collaboration.",
            "11:30 AM - 12:00 PM: Wrap-Up and Group Photo."
        ],
        teamIds: [2, 4],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d316122.2634907268!2d-83.4967363!3d35.6117666!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x885fb42a2b0d1231%3A0x9d4219adfe6cf88!2sGreat%20Smoky%20Mountains%20National%20Park!5e0!3m2!1sen!2sus!4v1715807364445!5m2!1sen!2sus",
    },
    {
        id: 4,
        image: images.event4,
        title: "Backpacking Trips",
        details: {
            date: "Sun, 09 Jun 2024",
            time: "6:00 AM - 6:00 PM",
            venue: "Mountain Base Camp",
            organizer: "Adventure Enthusiasts Association",
            number: "+123-456-7890",
            email: "info@adventurehub.com",
            entryFee: "$50 per person"
        },
        paragraphs: [
            "Embark on an unforgettable Backpacking Trip with fellow adventurers at the Mountain Base Camp. Explore stunning landscapes, conquer challenging trails, and enjoy the thrill of outdoor exploration.",
            "This full-day event includes guided treks, survival tips, and plenty of opportunities to connect with nature and fellow backpackers."
        ],
        gallery: [
            images.event4Gallery1,
            images.event4Gallery2
        ],
        agenda: [
            "6:00 AM - 7:00 AM: Arrival and Gear Check.",
            "7:00 AM - 11:00 AM: Morning Trek through Scenic Trails.",
            "11:00 AM - 12:00 PM: Break and Refreshments.",
            "12:00 PM - 3:00 PM: Backpacking Techniques and Trail Navigation Workshop.",
            "3:00 PM - 5:00 PM: Group Hike and Exploration.",
            "5:00 PM - 6:00 PM: Cool Down and Final Gathering."
        ],
        teamIds: [1, 3],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3086.661706144226!2d-105.6836386!3d40.3427938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876961af214250d3%3A0x38c0b3f1e0535e60!2sRocky%20Mountain%20National%20Park!5e0!3m2!1sen!2sus!4v1715807720987!5m2!1sen!2sus",
    },
    {
        id: 5,
        image: images.event5,
        title: "Environmental Awareness",
        details: {
            date: "Fri, 14 Jun 2024",
            time: "1:00 PM - 5:00 PM",
            venue: "Green Education Center",
            organizer: "Adventure Enthusiasts Association",
            number: "+123-456-7890",
            email: "info@adventurehub.com",
            entryFee: "$50 per person"
        },
        paragraphs: [
            "Join us for an impactful afternoon focused on raising awareness about environmental conservation and sustainability. This event brings together eco-enthusiasts, educators, and nature lovers to share insights and take action.",
            "Engage in interactive sessions, educational exhibits, and group discussions on how we can collectively protect our planet for future generations."
        ],
        gallery: [
            images.event5Gallery1,
            images.event5Gallery2
        ],
        agenda: [
            "1:00 PM - 1:30 PM: Welcome and Introduction to Environmental Goals.",
            "1:30 PM - 2:30 PM: Presentation on Local Conservation Efforts.",
            "2:30 PM - 3:30 PM: Group Activities and Discussions.",
            "3:30 PM - 4:30 PM: Hands-on Eco-Friendly Practices Workshop.",
            "4:30 PM - 5:00 PM: Closing Remarks and Networking."
        ],
        teamIds: [3, 2],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.356393370909!2d-122.4850277!3d37.7694218!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808580bb575ebfd1%3A0x1c84e51e92c2eaf3!2sGolden%20Gate%20Park!5e0!3m2!1sen!2sus!4v1715808123456!5m2!1sen!2sus",
    },
    {
        id: 6,
        image: images.event6,
        title: "Guided Hikes",
        details: {
            date: "Sun, 26 May 2024",
            time: "9:00 AM - 2:00 PM",
            venue: "Scenic Trailhead",
            organizer: "Adventure Enthusiasts Association",
            number: "+123-456-7890",
            email: "info@adventurehub.com",
            entryFee: "$50 per person"
        },
        paragraphs: [
            "Discover the beauty of nature with our Guided Hikes event at Scenic Trailhead. Whether you're a beginner or a seasoned hiker, this experience offers scenic views, fresh air, and a great workout.",
            "Led by experienced guides, enjoy educational commentary on local flora and fauna while building lasting connections with fellow adventurers."
        ],
        gallery: [
            images.event6Gallery1,
            images.event6Gallery2
        ],
        agenda: [
            "9:00 AM - 9:30 AM: Group Meetup and Safety Briefing.",
            "9:30 AM - 11:00 AM: Guided Hike through Scenic Trails.",
            "11:00 AM - 12:00 PM: Nature Education and Photo Spots.",
            "12:00 PM - 1:00 PM: Picnic Break.",
            "1:00 PM - 2:00 PM: Return Hike and Wrap-up."
        ],
        teamIds: [1, 4],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.588509833917!2d-121.742285!3d46.852385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54912173644fa897%3A0xc7413cf3c459c79f!2sMount%20Rainier%20National%20Park!5e0!3m2!1sen!2sus!4v1715808699987!5m2!1sen!2sus",
    }
];

export default events;